import {
  BioEthMethods,
  IBatch,
  Method,
  WineMethods,
  YeastMethods,
} from '@/features/single-measurement/types';
import { getAnalysesMethodDescription } from '@/features/single-measurement/utils/get-analyses-method-desc';
import { getStainOptions } from '@/features/user-settings';
import i18n from '@/locales/i18n';

const getURLPath = (method: Method, batchId: string) => {
  let prefix = '';
  if (WineMethods.includes(method)) {
    prefix = 'wine';
  } else if (YeastMethods.includes(method)) {
    prefix = 'beer';
  } else if (BioEthMethods.includes(method)) {
    prefix = 'ethanol';
  }
  return `https://webapp.oculyze.net/dashboard/${prefix}/measurements/${batchId}`;
};

export const formatBatch = (batch: IBatch) => {
  const {
    id,
    name,
    createdAt,
    email,
    description,
    density,
    temperature,
    resultStat,
    method,
    dilutionSample1,
    dilutionSample2,
    methodAttributes,
    dilutionStain1,
    dilutionStain2,
    // tags,
  } = batch;

  const stainOptions = getStainOptions();

  const stainMethod =
    stainOptions.find((stain) => stain.value === methodAttributes.stain)?.label || '';

  // TODO: Remove task temporary to keep the layout clean
  // const tasks = batch.tasks.map((task) => {
  //   const { countDead, countTotal, countBudding } = task.resultStat;
  //   return { countDead, countTotal, countBudding };
  // });

  let data: object = {
    Name: name ? name : id,
    Date: createdAt.toLocaleString(navigator.language, { dateStyle: 'long' }),
    Time: createdAt.toLocaleTimeString(navigator.language, { hour12: true }),
    User: email,
    Description: description ? description : '-',
    Concentration: resultStat.conz ? resultStat.conz.toFixed(2) : '-',
    Viability: resultStat.viab ? resultStat.viab.toFixed(2) : '-',
    'Budding Index': resultStat.bud ? resultStat.bud.toFixed(2) : '-',
    Density: density,
    Temperature: temperature,
    Method: i18n.t(getAnalysesMethodDescription(method)),
    'Dilution Sample': `${dilutionSample1 ?? 0} : ${dilutionSample2 ?? 0}`,
    // Tasks: batch.tasks.length > 0 ? JSON.stringify(tasks, null, 2) : '',
  };

  // TODO: Remove tags temporary to keep the layout clean
  // const tagStr = JSON.stringify(tags, null, 2);
  // if (tagStr !== '{}') data = { ...data, Tags: tagStr };

  if (
    [Method.WineConzViab, Method.Yeast2ConzViab, Method.BioEthConzViab].includes(method)
  ) {
    data = {
      ...data,
      'Dilution Stain': `${dilutionStain1 ?? 0} : ${dilutionStain2 ?? 0}`,
      'Stain Method': i18n.t(`${stainMethod}`),
    };
  }

  data = {
    ...data,
    'Analysis Link': getURLPath(method, id),
  };

  return data;
};
